module.exports = __webpack_public_path__ + "static/img/4.adf51a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/4.jpg
// module id = v0c4
// module chunks = 12